import { apiClient } from '@/shared/api/client';
import type { ApiResponse } from '@/shared/types/api.types';
import type {
  Education,
  CreateEducationRequest,
  UpdateEducationRequest,
} from '../types/education.types';

export const educationService = {
  async list(candidateId: string): Promise<Education[]> {
    const response = await apiClient<ApiResponse<Education[]>>(
      `/candidates/${candidateId}/educations`,
      { method: 'GET' }
    );
    return response.data;
  },

  async getById(candidateId: string, educationId: string): Promise<Education> {
    const response = await apiClient<ApiResponse<Education>>(
      `/candidates/${candidateId}/educations/${educationId}`,
      { method: 'GET' }
    );
    return response.data;
  },

  async create(candidateId: string, request: CreateEducationRequest): Promise<Education> {
    const response = await apiClient<ApiResponse<Education>>(
      `/candidates/${candidateId}/educations`,
      { method: 'POST', body: request }
    );
    return response.data;
  },

  async update(
    candidateId: string,
    educationId: string,
    request: UpdateEducationRequest
  ): Promise<Education> {
    const response = await apiClient<ApiResponse<Education>>(
      `/candidates/${candidateId}/educations/${educationId}`,
      { method: 'PUT', body: request }
    );
    return response.data;
  },

  async delete(candidateId: string, educationId: string): Promise<Education> {
    const response = await apiClient<ApiResponse<Education>>(
      `/candidates/${candidateId}/educations/${educationId}`,
      { method: 'DELETE' }
    );
    return response.data;
  },
};
